import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.currentComponent)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentComponent), {
        key: 0,
        params: _ctx.params
      }, null, 8, ["params"]))
    : (_ctx.isUnknownView())
      ? (_openBlock(), _createElementBlock("text", _hoisted_1, "unknown view: '" + _toDisplayString(_ctx.view) + "'", 1))
      : _createCommentVNode("", true)
}